export function doneIndicator(type) {
  return { type: `${type}_DONE` };
}

export function error(type, err) {
  return { type: type, payload: err, error: true };
}

export function errorIndicator(type) {
  return { type: `${type}_ERROR` };
}

export function load(type) {
  return { type: type, meta: { loading: true } };
}

export function success(type, payload) {
  return { type: type, payload: payload };
}

export function successIndicator(type) {
  return { type: `${type}_SUCCESS` };
}



// WEBPACK FOOTER //
// ./app/actions/standardActions.js